



















import { createComponent, computed } from "@vue/composition-api";
import { getResourceModule } from "@/apps/apps";
import { AppModule } from "../../shared/app";

interface Props {}

export default createComponent<Props>({
  components: {},
  props: {},
  filters: {
    capitalizeFirstLetter(str: string) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  setup(props, ctx) {
    const currentModule = computed(() => {
      const route = ctx.root.$route.matched.find((r) => r.meta.module);
      if (route) return route.meta.module as AppModule;
    });
    const currentAction = computed(() => {
      const route = ctx.root.$route.matched.find((r) => r.meta.action);
      if (route) return route.meta.action as string;
    });

    return { currentModule, currentAction };
  },
});
